// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-Widget.dialogOverlay .dialogBlock {
    border-radius: 3px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
    margin: 15px 20px;

    /* 
       padding (left + right) = 56px
       margin (left + right) = 40px
       total = padding + margin = 96px
    */
    max-width: calc(100% - 96px) !important;

    min-width: 424px;
    max-height: 560px;
    padding: 0 var(--arduino-button-height);
}

.p-Widget.dialogOverlay .dialogBlock .dialogTitle {
    padding: 20px 0;
    font-weight: 500;
    background-color: transparent;
    font-size: var(--theia-ui-font-size2);
    color: var(--theia-editorWidget-foreground);
    min-height: 0;
}

.p-Widget.dialogOverlay .dialogBlock .dialogControl {
    padding: 0 0 36px;
    min-height: 0;
}

.p-Widget.dialogOverlay .dialogBlock .dialogContent {
    padding: 0;
    overflow: auto;
}

.p-Widget.dialogOverlay .dialogBlock .dialogContent > input {
    margin-bottom: var(--arduino-button-height);
}

.p-Widget.dialogOverlay .dialogBlock .dialogContent > div {
    padding: 0 0 12px;
}

.p-Widget.dialogOverlay .dialogBlock .dialogContent .dialogSection {
    margin-top: var(--arduino-button-height);
}
.p-Widget.dialogOverlay .dialogBlock .dialogContent .dialogSection:first-child {
    margin-top: 0;
}

.p-Widget.dialogOverlay .dialogBlock .dialogContent .dialogSection .dialogRow {
    margin-top: 16px;
    display: flex;
    align-items: center;
}

.p-Widget.dialogOverlay .dialogControl .spinner,
.p-Widget.dialogOverlay
    .dialogBlock
    .dialogContent
    .dialogSection
    .dialogRow
    .spinner {
    background: var(--theia-icon-loading) center center no-repeat;
    animation: theia-spin 1.25s linear infinite;
    width: 30px;
    height: 30px;
}

.p-Widget.dialogOverlay
    .dialogBlock
    .dialogContent
    .dialogSection
    .dialogRow:first-child {
    margin-top: 0px;
    height: 32px;
}

.fl1 {
    flex: 1;
}

.status-icon {
    margin-right: 6px;
    font-size: 17px;
}

.fa.disabled {
    opacity: 0.4;
}

@media only screen and (max-height: 560px) {
    .p-Widget.dialogOverlay .dialogBlock {
        max-height: 400px;
    }
}

.p-Widget.dialogOverlay .error.progress {
    color: var(--theia-button-background);
    align-self: center;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/dialogs.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C,iBAAiB;;IAEjB;;;;KAIC;IACD,uCAAuC;;IAEvC,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;AAC5C;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;;IAOI,6DAA6D;IAC7D,2CAA2C;IAC3C,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;IAKI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB","sourcesContent":[".p-Widget.dialogOverlay .dialogBlock {\r\n    border-radius: 3px;\r\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);\r\n    margin: 15px 20px;\r\n\r\n    /* \r\n       padding (left + right) = 56px\r\n       margin (left + right) = 40px\r\n       total = padding + margin = 96px\r\n    */\r\n    max-width: calc(100% - 96px) !important;\r\n\r\n    min-width: 424px;\r\n    max-height: 560px;\r\n    padding: 0 var(--arduino-button-height);\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogTitle {\r\n    padding: 20px 0;\r\n    font-weight: 500;\r\n    background-color: transparent;\r\n    font-size: var(--theia-ui-font-size2);\r\n    color: var(--theia-editorWidget-foreground);\r\n    min-height: 0;\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogControl {\r\n    padding: 0 0 36px;\r\n    min-height: 0;\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogContent {\r\n    padding: 0;\r\n    overflow: auto;\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogContent > input {\r\n    margin-bottom: var(--arduino-button-height);\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogContent > div {\r\n    padding: 0 0 12px;\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogContent .dialogSection {\r\n    margin-top: var(--arduino-button-height);\r\n}\r\n.p-Widget.dialogOverlay .dialogBlock .dialogContent .dialogSection:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogContent .dialogSection .dialogRow {\r\n    margin-top: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogControl .spinner,\r\n.p-Widget.dialogOverlay\r\n    .dialogBlock\r\n    .dialogContent\r\n    .dialogSection\r\n    .dialogRow\r\n    .spinner {\r\n    background: var(--theia-icon-loading) center center no-repeat;\r\n    animation: theia-spin 1.25s linear infinite;\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.p-Widget.dialogOverlay\r\n    .dialogBlock\r\n    .dialogContent\r\n    .dialogSection\r\n    .dialogRow:first-child {\r\n    margin-top: 0px;\r\n    height: 32px;\r\n}\r\n\r\n.fl1 {\r\n    flex: 1;\r\n}\r\n\r\n.status-icon {\r\n    margin-right: 6px;\r\n    font-size: 17px;\r\n}\r\n\r\n.fa.disabled {\r\n    opacity: 0.4;\r\n}\r\n\r\n@media only screen and (max-height: 560px) {\r\n    .p-Widget.dialogOverlay .dialogBlock {\r\n        max-height: 400px;\r\n    }\r\n}\r\n\r\n.p-Widget.dialogOverlay .error.progress {\r\n    color: var(--theia-button-background);\r\n    align-self: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
